<template>
  <div>
    <label :for="prop">{{ label }}</label>
    <input :type="type" v-if="type != 'select'" v-model="data[prop]" @keyup="changed" @blur="changed"/>
    <select2 v-else-if="type == 'select'" v-model="data[prop]" :options="values" @change="changed" :settings="dropdownSettings">
    </select2>

  </div>
</template>
<script>

export default {
  props: {
    type:  {type: String, default: 'text'},
    label: {type: String, default: null},
    multiple: {type: Boolean, default: false},
    prop:  { type: String, default: null},
    value: { type: [String, Number], default: null},
    data:  { type: Object, default: () => {
      return {}
    } },
    errors:  { type: Object, default: () => {
      return {}
    } },
    values:  { type: Array, default: () => {
      return []
    } }
  },
  computed: {
    dropdownSettings(){
      return { placeholder: 'Bitte wählen Sie:', dropdownCssClass: 'dropdown-shadow', multiple: this.multiple }
    }
  },
  methods: {
    changed(payload){
      if (payload.currentTarget){
        this.$emit('changed', payload.currentTarget.value)
      }
    }
  }
}

</script>